var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallMountainGray(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 0l48 48L220 88.5H0l53-53L73.5 56l56-56z",
    fill: "#292929"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMountainGray);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg width='220' height='89' viewBox='0 0 220 89' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M129.5 0L177.5 48L220 88.5H0L53 35.5L73.5 56L129.5 0Z' fill='%23292929'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };